import { observer } from 'mobx-react';
import React, { useEffect } from 'react';

export const CreditAuthorizationDocusignCallback = observer(() => {
  useEffect(() => {
    const { search } = location || {};
    if (search) {
      const { origin } = window.parent.location;
      const parsed = search.replace('?', '').split('=');
      if (parsed[1] === 'signing_complete') {
        window.parent.postMessage('credit-authorization-docusign-done', origin);
      } else {
        window.parent.postMessage(
          'credit-authorization-docusign-incomplete',
          origin
        );
      }
    }
  }, []);

  return <></>;
});
